import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let ECampaignTargetRef;
(function (ECampaignTargetRef) {
  ECampaignTargetRef["Patient"] = "patient";
})(ECampaignTargetRef || (ECampaignTargetRef = {}));
export let ECampaignTargetStatus;
(function (ECampaignTargetStatus) {
  ECampaignTargetStatus["Created"] = "created";
})(ECampaignTargetStatus || (ECampaignTargetStatus = {}));
export let ECampaignTargetSource;
(function (ECampaignTargetSource) {
  ECampaignTargetSource["ConditionsSet"] = "conditionsSet";
  ECampaignTargetSource["Upload"] = "upload";
  ECampaignTargetSource["Manual"] = "manual";
})(ECampaignTargetSource || (ECampaignTargetSource = {}));
export const fieldsCampaignTarget = _extends({}, fieldsIBaseModel, {
  campaign: {
    type: 'ID',
    ref: EModel.Campaign
  },
  currentStream: {
    type: 'Object'
  },
  previousStreams: {
    type: 'Object',
    array: true
  },
  ref: {
    type: 'Option',
    values: ECampaignTargetRef
  },
  refId: {
    type: 'Text'
  },
  source: {
    type: 'Option',
    values: ECampaignTargetSource
  }
});